import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Asset } from 'src/app/shared/models/asset.model';
import { AppService } from 'src/app/shared/services/app.service';
import { AssetService } from 'src/app/shared/services/asset.service';

@Component({
  selector: 'app-product-overview',
  templateUrl: './product-overview.component.html',
  styleUrls: ['./product-overview.component.scss']
})
export class ProductOverviewComponent implements OnInit {
  private sub: any;
  public asset: Asset = new Asset();
  public isTermsAgreed: boolean = false;
  public assetNumber: string;
  public selectedLanguage: string;
  
  constructor(private router: Router, private appService: AppService, private activatedRoute: ActivatedRoute, public assetService: AssetService, public translate: TranslateService) { }

  ngOnInit(): void {
    this.appService.setProgress("25");
    this.appService.getLanguage().subscribe(language => {
      this.selectedLanguage = language;
    });
    this.sub = this.activatedRoute.params.subscribe((params) => {
      this.assetNumber = params["serialNumber"];
      this.assetService.getAssetBySerialNumber(params["serialNumber"]).subscribe(data => {
        this.asset = data;
      })
    });
  }

  public onSubmit(queryParam: string) {
    this.appService.setAsset(this.asset);
  
    if(queryParam.toLowerCase() == "broken"){
      this.router.navigate(["/description/" + this.assetNumber], { queryParams: {type: queryParam}});
    } else{
      this.router.navigate(["/request/" + this.assetNumber], {queryParams: {type: queryParam}});
    }
    
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
